import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { ENUM__connection_state } from '@/enums/ENUM__connection_state';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_app_info, use_slice_network } from '@/hooks/store/use_slices';
import { LOCAL__global_reset } from '@/state/_base/LOCAL__global_reset';
import { local_app_info_upsert } from '@/state/app_info/local_app_info_upsert';
import { EMaintenanceStatus } from '@shared/dto/app_info/e_maintenance_status';

export function WatcherConnectionError() {
  const dispatch = use_dispatch();
  const { state, connect_attempts_after_last_disconnect } = use_slice_network(['state', 'connect_attempts_after_last_disconnect']);
  const { app_info } = use_slice_app_info(['app_info']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (state != ENUM__connection_state.DISCONNECTED) return;

    dispatch(LOCAL__global_reset());
  }, [state]);

  use_effect(() => {
    if (connect_attempts_after_last_disconnect <= CONSTANTS__client.CONNECTION_ATTEMPTS_BEFORE_SHOW_MAINTENANCE) return; //didnt try connect yet
    if (app_info.is_maintenance_mode_enabled()) return; //already maintenance mode enabled

    let app_info_new = app_info.clone({ maintenance_status: EMaintenanceStatus.ENABLED_TILL_RESTART_APP });

    dispatch(local_app_info_upsert(app_info_new));
  }, [state, connect_attempts_after_last_disconnect]);

  return <></>;
}
